import type { SVGProps } from 'react';
const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="m20.516 11.144-15-9a.997.997 0 0 0-1.006-.012.992.992 0 0 0-.509.869v18a.998.998 0 0 0 1.516.856l15-9a1 1 0 0 0 0-1.712zM6 19.234V4.765l12.056 7.234L6 19.233z" />
  </svg>
);
export default SvgPlay;
